import { Map, View } from 'ol';
import { Control } from 'ol/control';

export class OLMap {
  private map!: Map;
  private view!: View;
  private controls: Control[] = [];

  constructor(map: Map) {
    this.map = map;
    this.view = map.getView();
  }

  public addControl(element: HTMLElement | undefined) {
    const control = new Control({ element });
    this.map.addControl(control);
    this.controls.push(control);
  }

  public getZoom(): number {
    return this.map.getView().getZoom();
  }

  public onMoveEnd(callable: () => void): void {
    this.map.on('moveend', callable);
  }

  public setTarget(target: string) {
    this.map.setTarget(target);
  }
}
